enum BiometryStatus {
  DEFAULT = 'default',
  FAILED = 'failed',
  SUCCESS = 'success',
  WAITING = 'waiting',
}

export default BiometryStatus;
